<script>
  export let width
  export let height
  export let cases
  export let scaleX
  export let scaleY
  export let xTicks
  export let yTicks
  export let prov
  console.log(yTicks)
  import { formatDateShort } from '../functions.js'
</script>

<div class="chart-title">{prov}</div>
<svg {width} {height}>
  {#each yTicks as tick}
    <line
      x1="10"
      x2={width - 10}
      y1={scaleY(tick)}
      y2={scaleY(tick)}
      stroke="lightgray"
      stroke-width="1"
    />
    <text class="y-axis" x="30" y={scaleY(tick)}> {tick} </text>
  {/each}
  {#each cases as d}
    <rect
      width="2"
      height={height - scaleY(d.daily_cases)}
      x={scaleX(d.date)}
      y={scaleY(d.daily_cases)}
    />
  {/each}
  <text x={scaleX(cases[0].date)} y={height + 15} class="x-axis x-axis-left">
    {formatDateShort(cases[0].date)}</text
  >
  <text
    x={scaleX(cases[cases.length - 1].date)}
    y={height + 15}
    class="x-axis x-axis-right"
  >
    {formatDateShort(cases[cases.length - 1].date)}</text
  >
</svg>

<style>
  svg {
    border: none;
  }
  .chart-title {
    font-size: 1rem;
    text-transform: uppercase;
  }
</style>
